//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
    carousel_type: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/home-page-carousel/{carousel_type} -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    action_template: t.union([t.null, t.undefined, t.string]),
    bg_color: t.union([t.null, t.undefined, t.string]),
    btn_color: t.union([t.null, t.undefined, t.string]),
    btn_link: t.union([t.null, t.undefined, t.string]),
    btn_title: t.union([t.null, t.undefined, t.string]),
    campaign_id: t.union([t.null, t.undefined, t.string]),
    carousel_type: t.string,
    competition_id: t.union([t.null, t.undefined, t.number]),
    date_from: t.string,
    date_to: t.string,
    display_order: t.number,
    email_opt_in_filter: t.union([t.null, t.undefined, t.string]),
    event_id: t.union([t.null, t.undefined, t.number]),
    exclude_promo_banned: t.union([t.null, t.undefined, t.boolean]),
    game_id: t.union([t.null, t.undefined, t.number]),
    id: t.number,
    img_url: t.union([t.null, t.undefined, t.string]),
    is_active: t.boolean,
    is_desktop: t.boolean,
    is_mobile: t.boolean,
    is_show_for_all_users: t.union([t.null, t.undefined, t.boolean]),
    market_id: t.union([t.null, t.undefined, t.number]),
    media_type: t.string,
    selections_details: t.unknown,
    sport: t.union([t.null, t.undefined, t.string]),
    stake_factor: t.union([t.null, t.undefined, t.array(t.string)]),
    stake_factor_range: t.union([t.null, t.undefined, t.string]),
    subtitle: t.string,
    tc_text: t.union([t.null, t.undefined, t.string]),
    title: t.string,
    universe: t.string,
    users_ids: t.union([t.null, t.undefined, t.string]),
    visibility_mode: t.union([t.null, t.undefined, t.string]),
    xtremepush_campaign_url: t.union([t.null, t.undefined, t.string]),
}));
export type Response200Type = Array<{
    action_template?: null | undefined | string;
    bg_color?: null | undefined | string;
    btn_color?: null | undefined | string;
    btn_link?: null | undefined | string;
    btn_title?: null | undefined | string;
    campaign_id?: null | undefined | string;
    carousel_type: string;
    competition_id?: null | undefined | number;
    date_from: string;
    date_to: string;
    display_order: number;
    email_opt_in_filter?: null | undefined | string;
    event_id?: null | undefined | number;
    exclude_promo_banned?: null | undefined | boolean;
    game_id?: null | undefined | number;
    id: number;
    img_url?: null | undefined | string;
    is_active: boolean;
    is_desktop: boolean;
    is_mobile: boolean;
    is_show_for_all_users?: null | undefined | boolean;
    market_id?: null | undefined | number;
    media_type: string;
    selections_details: unknown;
    sport?: null | undefined | string;
    stake_factor?: null | undefined | Array<string>;
    stake_factor_range?: null | undefined | string;
    subtitle: string;
    tc_text?: null | undefined | string;
    title: string;
    universe: string;
    users_ids?: null | undefined | string;
    visibility_mode?: null | undefined | string;
    xtremepush_campaign_url?: null | undefined | string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.unknown;
export type Response400Type = unknown;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.unknown;
export type Response401Type = unknown;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response404IO = t.unknown;
export type Response404Type = unknown;
export const decodeResponse404 = createGuard(404, Response404IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetHomePageCarouselRequest"
 */
export const openapi_website_cms_getHomePageCarousel = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {


    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/home-page-carousel/${params.carousel_type}${query}`;

    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetHomePageCarouselParamsType = ParamsType;

export type OpenapiWebsiteCmsGetHomePageCarouselResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 404;
    body: Response404Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetHomePageCarouselResponse200Type = Response200Type;

export const openapiWebsiteCmsGetHomePageCarouselRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetHomePageCarouselResponseType> => {
    const response = await openapi_website_cms_getHomePageCarousel(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 404) {
        return { status: 404, body: decodeResponse404(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetHomePageCarouselRequest - unhandled response ${response.status}`);
};

